export default __webpack_public_path__ + "c845d19f4cf5cf26ee60b5c9cdf8aee3.png";